// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 524) return "app.4bb0668dd8c0a922d21e.css";
	// return url for filenames based on template
	return "home.module" + "." + "1277d5be8f78fc645c8f" + ".chunk.css";
};